import React from 'react';
import useAuthenticationStore from './Store';
import VerifyEmail from './VerifyEmail';

const VerifyEmailContainer: React.FC = () => {
  const { state } = useAuthenticationStore()
  const { serverError, isLoading } = state

  return (
    <VerifyEmail
      serverError={serverError}
      isLoading={isLoading}
    />
  )
}

export default VerifyEmailContainer